import React from 'react'
import PropTypes from 'prop-types'

import S from './V1.styled'
import Logo from '../../logo/Logo'
import ToTop from '../../totop/ToTop'
import Social from '../../social/Social'
import Legal from '../../legal/Legal'
import Language from '../../language/Language'
import FooterAvailability from '../../availability/Availability'

const Footer = ({
  children = null,
  themeColor = 'dark',
  toTopText = '',
  availabilityText = '',
  defaultLinkTheme = 'marketing',
  socialLinks = null,
  addLegalLinks = [],
  legalLinkText = {},
  enableTracking = false,
  pageOrScreen = '',
  showAvailability = false,
  showPrivacyLink = true,
  showTermsLink = true,
  showBlogLink = true,
  showConsentModal = true,
  showFrGenderEqualityLink = false,
  showUkMsaLink = true,
  lang = 'en',
  intl = {},
  isLangFiltered = true,
  disableAllTargetBlank = false,
}) => {
  if (children) {
    return (
      <S.Footer className="footer" themeColor={themeColor}>
        <S.Container>{children}</S.Container>
      </S.Footer>
    )
  }

  const displayAvailability =
    defaultLinkTheme === 'marketing' || showAvailability

  return (
    <S.Footer className="footer" themeColor={themeColor}>
      <S.Container>
        <ToTop lang={lang} toTopText={toTopText} />
        <Social
          defaultLinkTheme={defaultLinkTheme}
          socialLinks={socialLinks}
          lang={lang}
          disableAllTargetBlank={disableAllTargetBlank}
        />
        <Language
          intl={intl}
          currentLocale={lang}
          isLangFiltered={isLangFiltered}
        />
        <Legal
          defaultLinkTheme={defaultLinkTheme}
          addLegalLinks={addLegalLinks}
          legalLinkText={legalLinkText}
          showPrivacyLink={showPrivacyLink}
          showTermsLink={showTermsLink}
          showBlogLink={showBlogLink}
          showConsentModal={showConsentModal}
          showFrGenderEqualityLink={showFrGenderEqualityLink}
          showUkMsaLink={showUkMsaLink}
          enableTracking={enableTracking}
          pageOrScreen={pageOrScreen}
          disableAllTargetBlank={disableAllTargetBlank}
          lang={lang}
        />
        {displayAvailability && (
          <FooterAvailability lang={lang} availabilityText={availabilityText} />
        )}
        <Logo />
      </S.Container>
    </S.Footer>
  )
}

Footer.propTypes = {
  children: PropTypes.node,
  themeColor: PropTypes.string,
  toTopText: PropTypes.string,
  availabilityText: PropTypes.string,
  defaultLinkTheme: PropTypes.string,
  socialLinks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  addLegalLinks: PropTypes.array,
  legalLinkText: PropTypes.object,
  enableTracking: PropTypes.bool,
  pageOrScreen: PropTypes.string,
  showAvailability: PropTypes.bool,
  showPrivacyLink: PropTypes.bool,
  showTermsLink: PropTypes.bool,
  showBlogLink: PropTypes.bool,
  showConsentModal: PropTypes.bool,
  showFrGenderEqualityLink: PropTypes.bool,
  showUkMsaLink: PropTypes.bool,
  lang: PropTypes.string,
  intl: PropTypes.shape({
    changeLocale: PropTypes.func,
    languageList: PropTypes.object,
  }),
  isLangFiltered: PropTypes.bool,
  disableAllTargetBlank: PropTypes.bool,
}

export default Footer
